import './styles.scss';
import React from 'react';
import { BeatLoader, ClipLoader as ReactSpinner } from 'react-spinners';

interface ClipLoaderComponentProps {
    size?: number;
    className?: string;
    color?: 'black' | 'accent';
    type?: 'Spinner' | 'Beat';
}

export class ClipLoader extends React.Component<ClipLoaderComponentProps> {
    private readonly defaultSize = 25;

    public render(): JSX.Element {
        const extraClasses = this.props.color === 'accent' ? 'clipLoaderAccent' : '';
        const color = this.props.color === 'accent' ? '#ee7012' : undefined;

        return (
            <div className={`clipLoaderWrapper ${this.props.className} ${extraClasses}`}>
                {this.props.type === 'Beat' ? (
                    <BeatLoader size={this.props.size || this.defaultSize} />
                ) : (
                    <ReactSpinner size={this.props.size || this.defaultSize} color={color} />
                )}
            </div>
        );
    }
}
